import Vue from 'vue'
import ability from './ability'

const abilitiesPlugin = {
  install(VueConstructor, abilityInstance) {
    VueConstructor.mixin({
      beforeCreate() {
        this.$ability = abilityInstance
      },
      methods: {
        $can(...args) {
          return abilityInstance.can(...args)
        },
      },
    })
  },
}

Vue.use(abilitiesPlugin, ability)
